<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>
            <b>Create patient</b>
          </v-card-title>
          <v-card-text class="text--primary">
            <v-row no-gutters>
              <v-col cols="9" md="8" lg="9">
                <v-text-field label="Name"
                              v-model="name"
                              outlined
                              dense
                              :error-messages="getValidationErrorsByField('name')"></v-text-field>
              </v-col>
              <v-col cols="3" md="4" lg="3">
                <v-select
                    ref="gender"
                    class="form-item ml-1"
                    v-model="gender"
                    :items="availableGenders"
                    item-text="title"
                    item-value="value"
                    outlined
                    dense
                    label="Gender"
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-menu
                    v-model="patientBirthdayMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{}">
                    <v-text-field
                        v-model="patientBirthdayInput"
                        :error-messages="getValidationErrorsByField('birthday')"
                        append-icon="event"
                        outlined
                        dense
                        placeholder="DD.MM.YYYY"
                        v-mask="'##.##.####'"
                        @click:append="patientBirthdayMenu = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="patientBirthday"
                                 ref="patientBirthdayPicker"
                                 @input="patientBirthdayMenu = false"
                                 first-day-of-week="1"
                                 :locale="$i18n.locale"
                                 :min="minBirthday"
                                 show-current="1980-01-01"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field label="Email"
                              v-model="email"
                              outlined
                              dense
                              :error-messages="getValidationErrorsByField('email')"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field label="Phone"
                              v-model="phone"
                              outlined
                              dense
                              :error-messages="getValidationErrorsByField('phone')"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field label="Address"
                              v-model="address"
                              outlined
                              dense
                              :error-messages="getValidationErrorsByField('address')"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                    v-model="comment"
                    label="Comment"
                    rows="3"
                    outlined
                    dense
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success"  @click="handleCreateButtonClick"
                   :loading="progress('patients.createPatient')">
              Create
            </v-btn>
            <v-btn @click="handleCancelButtonClick">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {mapGetters, mapState, mapActions} from 'vuex'
import moment from 'moment'
import {reformatDate} from "@/helpers/timeformats";
import {initCreationPatient} from "@/store/modules/patients/actions/createPatient";

export default {
  name: 'CreatePatient',
  data() {
    return {
      patientBirthdayMenu: false
    }
  },
  computed: {
    ...mapGetters({
      progress: 'progress'
    }),
    ...mapState('patients', {
      creationPatient: 'creationPatient'
    }),
    ...mapState({
      availableGenders: 'availableGenders'
    }),
    minBirthday() {
      return moment().subtract(100, 'years').format('YYYY-MM-DD')
    },
    name: {
      get() {
        return this.creationPatient.data.name
      },
      set(value) {
        this.setCreationPatientFieldDebounced('name', value)
      }
    },
    gender: {
      get() {
        return this.creationPatient.data.gender
      },
      set(value) {
        this.setCreationPatientFieldDebounced('gender', value)
      }
    },
    patientBirthday: {
      get() {
        return _.get(this.creationPatient, ['data', 'birthday'], null)
      },
      set(value) {
        this.setCreationPatientField('birthday', value)
      }
    },
    patientBirthdayInput: {
      get() {
        return reformatDate(this.patientBirthday)
      },
      set(value) {
        const date = moment(value, "DD.MM.YYYY", true)
        if (!date.isValid()) {
          return
        }

        this.patientBirthday = date.format('YYYY-MM-DD')
      }
    },
    email: {
      get() {
        return this.creationPatient.data.email
      },
      set(value) {
        this.setCreationPatientFieldDebounced('email', value)
      }
    },
    phone: {
      get() {
        return this.creationPatient.data.phone
      },
      set(value) {
        this.setCreationPatientFieldDebounced('phone', value)
      }
    },
    address: {
      get() {
        return this.creationPatient.data.address
      },
      set(value) {
        this.setCreationPatientFieldDebounced('address', value)
      }
    },
    comment: {
      get() {
        return this.creationPatient.data.comment
      },
      set(value) {
        this.setCreationPatientFieldDebounced('comment', value)
      }
    }
  },
  methods: {
    ...mapActions('patients', {
      initCreationPatient: 'initCreationPatient',
      createPatient: 'createPatient',
      updateCreationPatientField: 'updateCreationPatientField'
    }),
    getValidationErrorsByField(fieldName) {
      return _.get(this.creationPatient, ['validationErrorsByFields', fieldName], [])
    },
    setCreationPatientFieldDebounced: _.debounce(function (fieldName, value) {
      return this.setCreationPatientField(fieldName, value)
    }, 200),
    setCreationPatientField: function (fieldName, value) {
      let resultValue = _.cloneDeep(value)
      if (value === '') {
        resultValue = null
      }

      this.updateCreationPatientField({
        fieldName: fieldName,
        value: resultValue,
      })
    },
    async handleCreateButtonClick() {
      const createdPatient = await this.createPatient()

      if (!createdPatient) {
        return false
      }

      this.$router.push(`/patients/${createdPatient.id}`)
    },
    handleCancelButtonClick() {
      this.initCreationPatient()
    }
  }
}
</script>

<style scoped>

</style>